module.exports = __webpack_public_path__ + "static/jcsj-482d59481da4a34c07768d1f371394ca.jpg";